import { render, staticRenderFns } from "./TaskActions.vue?vue&type=template&id=f2fff378&scoped=true"
import script from "./TaskActions.vue?vue&type=script&lang=ts"
export * from "./TaskActions.vue?vue&type=script&lang=ts"
import style0 from "./TaskActions.vue?vue&type=style&index=0&id=f2fff378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fff378",
  null
  
)

export default component.exports